
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.75 5h10.031l-.094 1.063-.188 3-.063.938h-2l-.875 12h2l-.063 1.063-.188 3-.063.938H10.216l.094-1.063.188-3 .063-.938h2l.875-12h-2l.063-1.063.188-3zm1.875 2l-.063 1h2l-.063 1.063-1 14-.063.938h-2l-.063 1h6l.063-1h-2l.063-1.063 1-14L17.562 8h2l.063-1h-6z"}})])
          )
        }
      }
    